export default function CarFridge() {
    return (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_608_33128)">
                <path
                    d="M26.5363 5.80615H7.13971C6.29399 5.80615 5.6084 6.49174 5.6084 7.33746V25.7131C5.6084 26.5589 6.29399 27.2444 7.13971 27.2444H26.5363C27.382 27.2444 28.0676 26.5589 28.0676 25.7131V7.33746C28.0676 6.49174 27.382 5.80615 26.5363 5.80615Z"
                    stroke="black"
                    strokeWidth="1.53131"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.7545 8.86865H5.6084V12.9521H11.2232C12.0689 12.9521 12.7545 12.2665 12.7545 11.4208V8.86865Z"
                    stroke="black"
                    strokeWidth="1.53131"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12.7544 27.2441H8.6709V28.265H12.7544V27.2441Z" stroke="black" strokeWidth="1.53131" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25.0044 27.2441H20.9209V28.265H25.0044V27.2441Z" stroke="black" strokeWidth="1.53131" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.6084 8.86865H28.0676" stroke="black" strokeWidth="1.53131" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_608_33128">
                    <rect width="32.6679" height="32.6679" fill="white" transform="translate(0.503906 0.70166)" />
                </clipPath>
            </defs>
        </svg>
    );
}
